document.addEventListener('DOMContentLoaded', function () {
  const rutInput = document.getElementById('rut');
  const razonInput = document.getElementById('razon_social');
  const direccionInput = document.getElementById('direccion');
  const comunaInput = document.getElementById('comuna');
  const correoInput = document.getElementById('correo');
  const fonoInput = document.getElementById('fono');
  const downloadButton = document.getElementById('download-quote');
  const rutError = document.getElementById('rut-error');

  //Validar RUT en vivo mientras escribe
  rutInput.addEventListener('input', function () {
    validarCampoRut();
    validarSoloEstadoBoton(); // Solo controlar botón
  });

  //Validar el estado del botón mientras escribe en los demás campos
  [razonInput, direccionInput, comunaInput, correoInput, fonoInput].forEach(input => {
    input.addEventListener('input', function () {
      validarSoloEstadoBoton(); // Solo controlar el botón
    });
  });

  //Validar todo cuando intente descargar
  downloadButton.addEventListener('click', function (e) {
    const formValid = validarFormulario();
    if (!formValid) {
      e.preventDefault(); //Bloquea la descarga si es inválido
      console.log("Formulario inválido, corregir errores antes de continuar.");
    }
  });

  //Solo activar o desactivar el botón, sin mostrar errores
  function validarSoloEstadoBoton() {
    const rutValido = validarCampoRut(false); //Validar sin mostrar error
    const razonNoVacia = razonInput.value.trim() !== '';
    const direccionNoVacia = direccionInput.value.trim() !== '';
    const comunaNoVacia = comunaInput.value.trim() !== '';
    const correoValido = validarCorreoSoloEstado(correoInput);
    const fonoNoVacio = fonoInput.value.trim() !== '';

    if (rutValido && razonNoVacia && direccionNoVacia && comunaNoVacia && correoValido && fonoNoVacio) {
      downloadButton.disabled = false;
    } else {
      downloadButton.disabled = true;
    }
  }

  //Validar todo mostrando errores
  function validarFormulario() {
    const rutValido = validarCampoRut(true);
    const razonNoVacia = validarCampoVacio(razonInput);
    const direccionNoVacia = validarCampoVacio(direccionInput);
    const comunaNoVacia = validarCampoVacio(comunaInput);
    const correoValido = validarCampoCorreo(correoInput);
    const fonoNoVacio = validarCampoVacio(fonoInput);

    if (rutValido && razonNoVacia && direccionNoVacia && comunaNoVacia && correoValido && fonoNoVacio) {
      downloadButton.disabled = false;
      return true;
    } else {
      downloadButton.disabled = true;
      return false;
    }
  }

  //Validar RUT (puede o no mostrar error)
  function validarCampoRut(mostrarErrorEnPantalla = true) {
    if (mostrarErrorEnPantalla) {
      limpiarErrores(rutInput, rutError);
    }

    const rut = rutInput.value.trim();
    if (!rut || !validarRUT(rut)) {
      if (mostrarErrorEnPantalla) {
        mostrarError(rutInput, rutError);
      }
      return false;
    }
    return true;
  }

  //Validar campo vacío
  function validarCampoVacio(input) {
    const errorDiv = input.nextElementSibling;
    limpiarErrores(input, errorDiv);

    if (input.value.trim() === '') {
      mostrarError(input, errorDiv);
      return false;
    }
    return true;
  }

  //Validar correo completo
  function validarCampoCorreo(input) {
    const errorDiv = input.nextElementSibling;
    limpiarErrores(input, errorDiv);

    const correo = input.value.trim();
    const regexCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (correo === '' || !regexCorreo.test(correo)) {
      mostrarError(input, errorDiv);
      return false;
    }
    return true;
  }

  //Solo validar correo para habilitar/deshabilitar botón (sin mostrar error)
  function validarCorreoSoloEstado(input) {
    const correo = input.value.trim();
    const regexCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return correo !== '' && regexCorreo.test(correo);
  }

  //Mostrar error
  function mostrarError(input, errorDiv = null) {
    if (input) input.classList.add('input-error');
    if (errorDiv) errorDiv.style.display = 'block';
  }

  //Limpiar errores
  function limpiarErrores(input, errorDiv = null) {
    if (input) input.classList.remove('input-error');
    if (errorDiv) errorDiv.style.display = 'none';
  }

  //Validación del RUT Chileno
  function validarRUT(rut) {
    rut = rut.replace(/\./g, '').replace(/-/g, '').toUpperCase();
    if (rut.length < 8) return false;

    const cuerpo = rut.slice(0, -1);
    const dv = rut.slice(-1);

    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo.charAt(i)) * multiplo;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    const dvEsperado = 11 - (suma % 11);
    const dvCalculado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();

    return dv === dvCalculado;
  }
});